// extracted by mini-css-extract-plugin
export default {"dualButton":"DualButton_dualButton__RsgCr","button":"DualButton_button__lAJIG","first":"DualButton_first__zNn9Q","second":"DualButton_second__x0o-k"};